import { Input, Modal, message } from 'antd';
import Utils from '@utils/utils'
import { useEffect, useState, useRef } from 'react';
import eventBus from '@utils/eventBus';
import styles from './inviteUserModal.module.scss'
import API from '@api/api';
import RecordModal from './RecordModal';



const InviteModal = (props) => {
    const [open, setOpen] = useState(false)

    const handleInvite = () => {
        setOpen(true)
    }

    useEffect(() => {
        eventBus.on('inviteUser', handleInvite);
        return () => {
            eventBus.off('inviteUser', handleInvite);
        }
    }, [])

    const onCancelClick = () => {
        setOpen(false)
    }

    useEffect(() => {
        if (!open) return
        getInvitationInfo()
    }, [open])

    const [infoData, setInfoData] = useState({})
    const getInvitationInfo = () => {
        if (!localStorage.getItem('token')) return
        API.getInvitationInfo({
        }).then((res) => {
            if (res.code == 0) {
                setInfoData(res.data)
            }
        })
    }

    const copyLink = (link) => {
        if (!link) return;
        const fullLink = link;

        // 如果 clipboard API 可用
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(fullLink)
                .then(() => {
                    message.success('复制成功');
                })
                .catch(err => {
                    console.error('Clipboard error:', err);
                    message.error('复制失败，请手动复制');
                });
        } else {
            // 兼容旧浏览器
            const textarea = document.createElement('textarea');
            textarea.value = fullLink;
            textarea.style.position = 'fixed';
            textarea.style.top = '-9999px';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();

            try {
                const success = document.execCommand('copy');
                if (success) {
                    message.success('复制成功');
                } else {
                    message.warning('复制失败，请手动复制');
                }
            } catch (err) {
                console.error('Fallback copy error:', err);
                message.error('复制失败，请手动复制');
            }
            document.body.removeChild(textarea);
        }
    }

    const recordModalRef = useRef(null);


    return (
        <>
            <Modal
                title={null}
                footer={null}
                centered
                destroyOnHidden
                open={open}
                getContainer='#root'
                width={652}
                wrapClassName={styles.InviteModal}
                onCancel={onCancelClick}
            >
                <div className={styles.InviteModal_body}>
                    <div className={styles.InviteModalBg}></div>
                    <div className={styles.copy_box}>
                        <span>{window.location.origin}?/invite_code={props?.invitationCode}</span>
                        <div className={styles.copy_box_btn} onClick={() => copyLink(`${window.location.origin}?/invite_code=${props?.invitationCode}`)}>复制邀请链接</div>
                    </div>
                    <div className={styles.statWrapper}>
                        <div className={styles.leftCard}>
                            <div className={styles.value}>{infoData?.totalAmount || 0}</div>
                            <div className={styles.desc}>已获虹豆</div>
                        </div>

                        <div className={styles.rightCard}>
                            <div className={styles.item}>
                                <div className={styles.value}>{infoData?.inviteNum || 0}</div>
                                <div className={styles.subDesc}>1人注册得100虹豆</div>
                                <div className={styles.desc}>已邀请注册好友数</div>
                            </div>

                            <div className={styles.divider} />

                            <div className={styles.item}>
                                <div className={styles.value}>{infoData?.orderNum || 0}</div>
                                <div className={styles.subDesc2}>每1人付费得300虹豆</div>
                                <div className={styles.desc}>已付费好友数</div>
                            </div>
                        </div>
                    </div>
                    <p className={styles.recordDesc}><span onClick={() => recordModalRef.current?.open()}>邀请记录</span></p>
                    <p className={styles.ruleDesc}>活动规则</p>
                    <p className={styles.ruleItem}><span>1、双重福利：</span>好友通过您的链接注册，您与Ta均可获100虹豆（有效期1个月），同时您累计1个邀请人数，每日最高可邀请50人</p>
                    <p className={styles.ruleItem}><span>2、特别奖励：</span>您邀请注册的好友首次购买任意套餐，您均可额外获得300红豆（有效期1年）</p>
                    <p className={styles.copyright}>*活动最终解释权归PhotoStudio® AI所有</p>
                </div>
            </Modal>
            <RecordModal ref={recordModalRef} />
        </>

    )
}

export default InviteModal